import { render, staticRenderFns } from "./UserScientificDegreeFilter.vue?vue&type=template&id=72cefb02&"
import script from "./UserScientificDegreeFilter.vue?vue&type=script&lang=js&"
export * from "./UserScientificDegreeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports